import { render, staticRenderFns } from "./StockDocumentLineTotals.vue?vue&type=template&id=1829feb2&scoped=true"
import script from "./StockDocumentLineTotals.vue?vue&type=script&lang=js"
export * from "./StockDocumentLineTotals.vue?vue&type=script&lang=js"
import style0 from "./StockDocumentLineTotals.vue?vue&type=style&index=0&id=1829feb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1829feb2",
  null
  
)

export default component.exports